import React, { Fragment, useState, useEffect } from 'react';
import TableBuilder, { ApiRequestBuilder, FormOptionsBuilder, RegisteredInputsBuilder, ModalButtonBuilder, ToastBuilder, ButtonBuilder } from '../../GlobalComponents/Builders';
import buildRandomId, { buildOptionsFromArray, uploadPresignedFile } from '../../GlobalComponents/Helpers';
import { Row, Card, CardBody, Form, CardFooter } from 'reactstrap'
import { useForm } from 'react-hook-form';
import { Col } from 'react-bootstrap';
import moment from 'moment';

const OEPCommissions = () => {

    const { register, handleSubmit, setValue, formState: { errors } } = useForm();

    const [salesReps, setSalesReps] = useState([]);
    const [searchQuery, setSearchQuery] = useState({});
    const [searchResults, setSearchResults] = useState([]);

    const handleCSVDownload = (data, fileName) => {
        if (data.data) {
            const element = document.createElement("a");
            const file = new Blob([data.data], {type: 'csv'});
            element.href = URL.createObjectURL(file);
            element.download = fileName + ".csv";
            document.body.appendChild(element);
            element.click();
        } else {
            ToastBuilder('error', 'We are unable to provide you with the export')
        }
    }

    const handleDocumentUpload = (file) => {
        if (file['connectionFileToUpload'].length === 0) {
            ToastBuilder('error', 'Please Select a File to Upload')
        } else {
            var fileId = buildRandomId(10);
            uploadPresignedFile(file['connectionFileToUpload'], 'filesUploadPost', null, {
                bucket: process.env.REACT_APP_FILES_BUCKET,
                key: file['connectionFileToUpload'][0].name,
                type: 'oepFile',
                metadata: {
                    fileid: fileId,
                    fileprefix: 'Commission Import: '
                }
            }, () => {
                ApiRequestBuilder('oepCommissionsImportPost', null, { fileId: fileId })
                    .then(function(data) { searchCommissions(searchQuery); data.data ? handleCSVDownload(data, 'duplicate_phone_numbers') : null })
            }, { timeout: '5000' })
        }
    }

    const handleOepAction = (action, myCallback = null, formData = { 'empty': 'body' }) => {
        ApiRequestBuilder('oepActionsActionNamePost', { actionName: action }, { ...formData })
            .then(function(results) {
                myCallback ? myCallback(results) : null
            })
    }

    const searchCommissions = (formData) => {
        setSearchQuery({})
        setSearchResults([])

        if (formData.searchFrom) {
            formData.searchFrom = moment.utc(formData.searchFrom).unix()
        }
        if (formData.searchTo) {
            formData.searchTo = moment.utc(formData.searchTo).unix()
        }

        ApiRequestBuilder('oepCommissionsSearchPost', null, formData)
            .then(function(results) {
                if (results.data && results.data.length > 0) {
                    setSearchQuery(formData)
                    setSearchResults(results.data)
                    ToastBuilder('success', 'Record Search Successful')
                } else ToastBuilder('info', 'No Records Matching Search')
            })
    }

    useEffect(() => {
        document.title = 'Commission Tracker'
        ApiRequestBuilder('oepSalesRepsGet')
            .then(function(reps) { setSalesReps([''].concat(reps.data)) })
    }, []);

    return (
        <Fragment>
            <Col xl="12">
                <Card>
                    <CardBody>
                        <Row>
                            <h4 className='col-md-7'>Commission Tracker</h4>
                            <ModalButtonBuilder title='Import Commissions' className='btn-secondary col-md-2 m-1' size='lg'
                                body={
                                    <Fragment>
                                        <p>This importer accepts .xlsx and .csv files containing three columns:</p>
                                            <li>Order Number (optional)</li>
                                            <li>Phone Number</li>
                                            <li>New Payment</li>
                                        <br/>
                                        <Form id='import-commissions-form' onSubmit={handleSubmit(handleDocumentUpload)}>
                                            <RegisteredInputsBuilder
                                                registrator={register}
                                                registratorErrors={errors}
                                                inputs={[
                                                    {
                                                        label: 'Choose A File',
                                                        size: 12,
                                                        name: 'connectionFileToUpload',
                                                        type: 'file',
                                                    }
                                                ]}
                                            />
                                        </Form>
                                    </Fragment>
                                }
                            />
                            <ButtonBuilder
                                label={'Back to Orders'}
                                className='btn-primary col-md-2 m-1'
                                onClick={() => { window.location.href = `${process.env.PUBLIC_URL}/oep`}}
                            />
                        </Row>
                        <br/>
                        { salesReps.length > 0 ?
                            <Form id='search-commissions-form' className='card' onSubmit={handleSubmit((data) => searchCommissions(data))}>
                                <CardBody>
                                    <Row>
                                    <RegisteredInputsBuilder
                                        registrator={register}
                                        registratorErrors={errors}
                                        inputs={[
                                            {
                                                label: 'Order #',
                                                name: 'orderNumber',
                                                inputSize: 4
                                            },
                                            {
                                                label: 'Sales Rep',
                                                type: 'select',
                                                inputSize: 4,
                                                required: false,
                                                options: <FormOptionsBuilder options={buildOptionsFromArray(salesReps, { labelIsValue: true })}/>,
                                                name: 'salesRep'
                                            },
                                            {
                                                label: 'Company',
                                                name: 'company',
                                                inputSize: 4
                                            },
                                            {
                                                label: 'Sim',
                                                name: 'sim',
                                                inputSize: 4
                                            },
                                            {
                                                label: 'Paid',
                                                type: 'select',
                                                required: false,
                                                options: <FormOptionsBuilder options={buildOptionsFromArray(['', 'Unpaid', 'Partially', 'Fully', 'Overpaid'], { labelIsValue: true })}/>,
                                                name: 'paid',
                                                inputSize: 4
                                            },
                                            {
                                                label: 'Carrier',
                                                type: 'select',
                                                required: false,
                                                options: <FormOptionsBuilder options={buildOptionsFromArray(['', 'AT&T', 'T-Mobile', 'Verizon'], { labelIsValue: true })}/>,
                                                name: 'carrier',
                                                inputSize: 4
                                            },
                                            {
                                                label: 'Act. Type',
                                                name: 'activationType',
                                                type: 'select',
                                                required: false,
                                                options: <FormOptionsBuilder options={buildOptionsFromArray(['', 'New', 'Upgrade'], { labelIsValue: true })}/>,
                                                inputSize: 4
                                            },
                                            {
                                                label: 'From',
                                                type: 'date',
                                                name: 'searchFrom',
                                                helpText: 'Activation Date Start',
                                                inputSize: 4
                                            },
                                            {
                                                label: 'To',
                                                type: 'date',
                                                name: 'searchTo',
                                                helpText: 'Activation Date End',
                                                inputSize: 4
                                            },
                                            {
                                                label: 'Mobile No.',
                                                name: 'phoneNumber',
                                                inputSize: 4
                                            }
                                        ]}/>
                                    </Row>
                                </CardBody>
                                <CardFooter className='text-end'>
                                    <ButtonBuilder form='search-commissions-form' label='Search' className='btn-primary m-2' />
                                    <ButtonBuilder form='' label='Reset' className='btn-secondary m-1' onClick={() => {
                                        setValue('orderNumber', '')
                                        setValue('paid', '')
                                        setValue('carrier', '')
                                        setValue('salesRep', '')
                                        setValue('sim', '')
                                        setValue('searchFrom', '')
                                        setValue('activationType', '')
                                        setValue('searchTo', '')
                                        setValue('phoneNumber', '')
                                    }}/>
                                </CardFooter>
                            </Form> : null}
                    </CardBody>
                </Card>
            </Col>
        { searchResults.length > 0 ?
            <Card>
                <CardBody>
                    <TableBuilder
                        data = {searchResults}
                        processing = {false}
                        subHeader={true}
                        title='Search Results'
                        columnsToSearch = {['paid', 'activation_type', 'company_name', 'carrier', 'phone_number', 'imei', 'sales_rep', 'sim']}
                        actions = {
                            <Fragment>
                                <ButtonBuilder label={'Export'} className='btn-primary m-1' onClick={() => ApiRequestBuilder('oepCommissionsSearchExportPost', null, searchQuery).then((data) => handleCSVDownload(data, 'commission_search_export'))}/>
                                <ButtonBuilder label={'Download Import Template'} className='btn-secondary m-1' onClick={() => handleCSVDownload({ data: "Order Number,Phone Number,New Payment"}, 'commission_import_template')}/>
                            </Fragment>
                        }
                        columns = {[
                            {
                                name: 'Commission Status',
                                selector: (row) => row.commission_status,
                                sortable: true,
                                center: true
                            },
                            {
                                name: 'Payment Status',
                                selector: (row) => row.paid,
                                sortable: true,
                                center: true
                            },
                            {
                                name: 'Expected',
                                selector: (row) => (row.item_commission_amount ? '$' + row.item_commission_amount : '-'),
                                sortable: true,
                                center: true
                            },
                            {
                                name: 'Paid to Date',
                                selector: (row) => row.amount_received ? '$' + row.amount_received : '$' + 0,
                                sortable: true,
                                center: true
                            },
                            {
                                name: 'Outstanding',
                                selector: (row) => row.item_commission_amount ? ('$' + Math.round((row.item_commission_amount - row.amount_received) * 100) / 100) : '-',
                                sortable: true,
                                center: true
                            },
                            {
                                name: 'Act Type',
                                selector: (row) => row.activation_type,
                                sortable: true,
                                center: true,
                                maxWidth: '6%'
                            },
                            {
                                name: 'Company',
                                selector: (row) => row.company_name,
                                sortable: true
                            },
                            {
                                name: 'Carrier',
                                selector: (row) => row.carrier,
                                sortable: true
                            },
                            {
                                name: 'Mobile',
                                selector: (row) => row.phone_number,
                                sortable: true
                            },
                            {
                                name: 'IMEI',
                                selector: (row) => row.imei,
                                sortable: true
                            },
                            {
                                name: 'Sim ID',
                                selector: (row) => row.sim,
                                sortable: true
                            },
                            {
                                name: 'Rate Plan',
                                selector: (row) => row.rate_plan,
                                sortable: true
                            },
                            {
                                name: 'Contract',
                                selector: (row) => row.contract,
                                sortable: true
                            },
                            {
                                name: 'Sales Rep',
                                selector: (row) => row.sales_rep,
                                sortable: true
                            },
                            {
                                name: 'Notes',
                                selector: (row) => row.line_instructions,
                                sortable: true,
                                center: true
                            },
                            {
                                name: 'Date',
                                selector: (row) => moment(row.activation_date * 1000).format('MM-DD-YYYY'),
                                sortable: true,
                                center: true,
                                sortFunction: (a, b) => a.activation_date - b.activation_date
                            },
                        ]}
                    />
                </CardBody>
            </Card>
        : null}
        </Fragment>
    )
};

export default OEPCommissions;
